import React, { useState, useEffect } from 'react';
import { Card, Button, Table, Badge, Spinner, Modal, Form, OverlayTrigger, Tooltip, Nav } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import { DUYET_KIEMTRASOLIEU_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { trangThaiKiemTraSoLieuValue, objectTrangThaiKiemTraSoLieu } from '@app/utils/define';
import { Get, Put } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import KiemTraSoLieuEdit from './KiemTraSoLieuEdit';
import DieuKienQuyetDinhForm from './DieuKienQuyetDinhForm';

const DuyetKiemTraSoLieu = ({ hoSoId, activeTab, setActiveTab }) => {
    const queryClient = useQueryClient();
    const [showModal, setShowModal] = useState(false);
    const [showDieuKienModal, setShowDieuKienModal] = useState(false);
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [trangThai, setTrangThai] = useState('');
    const [ghiChu, setGhiChu] = useState('');
    const [fileTaiLieu, setFileTaiLieu] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const { isLoading, data: queryData, refetch } = useQuery(
        ['duyetKiemTraSoLieuData', hoSoId],
        () => Get(DUYET_KIEMTRASOLIEU_API.GET_PAGING, null, { HoSoNghienCuuSinhId: hoSoId, PageIndex: 1, PageSize: 100 }),
        { 
            enabled: !!hoSoId && viewMode === 'list',
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        }
    }

    useEffect(() => {
        if (dataList && dataList.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = dataList.find(item => item.id === prev.id);
                    return fresh || dataList[0];
                }
                return dataList[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [dataList]);

    const handleAction = (item) => {
        setDataEdit(item);
        setTrangThai(item.trangThai || (objectTrangThaiKiemTraSoLieu.length > 0 ? objectTrangThaiKiemTraSoLieu[0].value : ''));
        setGhiChu(item.ghiChuChinhSua || '');
        setFileTaiLieu(item.fileTaiLieu || '');
        setShowModal(true);
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    const submitDuyet = async () => {
        if (!trangThai) {
            toast.warning('Vui lòng chọn trạng thái duyệt!');
            return;
        }

        const payload = {
            HoSoNghienCuuSinhId: hoSoId,
            SoLuongBaiBao: dataEdit.soLuongBaiBao,
            TrenCacTapChi: dataEdit.trenCacTapChi || '',
            LinkBaiBao: dataEdit.linkBaiBao || '',
            NgayKiemTra: dataEdit.ngayKiemTra || null,
            FileBaiBao: dataEdit.fileBaiBao || '',
            FileVanBanDongY: dataEdit.fileVanBanDongY || '',
            FileDanhSach: dataEdit.fileDanhSach || '',
            FileXacNhan: dataEdit.fileXacNhan || '',
            FileLuanAn: dataEdit.fileLuanAn || '',
            FileMinhChung: dataEdit.fileMinhChung || '',
            FileDonDeNghi: dataEdit.fileDonDeNghi || '',
            FileTaiLieu: fileTaiLieu,
            TrangThai: trangThai,
            GhiChuChinhSua: ghiChu
        };

        setIsSaving(true);
        try {
            const res = await Put(DUYET_KIEMTRASOLIEU_API.DUYET_HO_SO, dataEdit.id, payload);
            if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id || res.success)) {
                toast.success('Lưu thành công!');
                queryClient.invalidateQueries(['kiemTraSoLieuData', hoSoId]);
                refetch();
                setShowModal(false);
            } else {
                toast.error(res?.message || 'Có lỗi xảy ra');
            }
        } catch (error) {
            toast.error(error?.message || 'Có lỗi xảy ra');
        } finally {
            setIsSaving(false);
        }
    };

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiKiemTraSoLieuValue.choDuyet: return <Badge variant="warning">Chờ duyệt</Badge>;
            case trangThaiKiemTraSoLieuValue.boSung: return <Badge variant="info">Yêu cầu chỉnh sửa</Badge>;
            case trangThaiKiemTraSoLieuValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            case trangThaiKiemTraSoLieuValue.tuChoi: return <Badge variant="danger">Từ chối</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    return (
        <>
        <Card className="h-100 card-sticky-layout">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <Nav variant="pills" activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="flex-row">

                        <Nav.Item>
                            <Nav.Link eventKey="quaTrinhLaySoLieu" className="font-weight-bold">Quá trình lấy số liệu</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="kiemTraSoLieu" className="font-weight-bold">Kiểm tra số liệu</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <div className="table-responsive flex-grow-1">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="text-center" width="50">STT</th>
                                    <th className="text-center">Số lượng bài báo</th>
                                    <th>Các tạp chí</th>
                                    <th className="text-center">Ngày kiểm tra</th>
                                    <th className="text-center">File tài liệu</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th>Ghi chú</th>
                                </tr>
                            </thead>
                        <tbody>
                            {dataList.length > 0 ? (
                                dataList.map((item, index) => (
                                    <tr 
                                        key={item.id}
                                        onClick={() => setSelectedRow(item)}
                                        style={{ cursor: 'pointer' }}
                                        className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                    >
                                        <td className="text-center">{index + 1}</td>
                                        <td className="text-center">{item.soLuongBaiBao || 0}</td>
                                        <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{item.trenCacTapChi}</td>
                                        <td className="text-center">
                                            {item.ngayKiemTra ? moment(item.ngayKiemTra).format('DD/MM/YYYY') : ''}
                                        </td>
                                        <td className="text-center">
                                            {item.fileTaiLieu ? (
                                                (() => {
                                                    const path = item.fileTaiLieu;
                                                    const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                    const safePath = path.startsWith('/') ? path : `/${path}`;
                                                    const safeUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                    let name = path.split('/').pop() || 'File';
                                                    name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                    return (
                                                        <a href={safeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-info btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                            <i className="fas fa-paperclip mr-1"></i> {name}
                                                        </a>
                                                    );
                                                })()
                                            ) : <span className="text-muted">Chờ HLĐT gửi</span>}
                                        </td>
                                        <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                        <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{item.ghiChuChinhSua || ''}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted">
                                        Chưa có dữ liệu Kiểm tra số liệu
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    </div>
                )}
            </Card.Body>
            {!isLoading && (
                <Card.Footer className="bg-white card-footer-sticky">
                    <div className="d-flex justify-content-end pr-4">
                        <Button 
                            variant="primary" 
                            size="sm" 
                            onClick={() => { setDataEdit(selectedRow); setViewMode('view'); }} 
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-eye mr-1"></i> Xem chi tiết
                        </Button>
                        <Button 
                            variant="warning" 
                            size="sm" 
                            onClick={() => handleAction(selectedRow)} 
                            className="mr-2 text-white"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-tasks mr-1"></i> Cập nhật trạng thái
                        </Button>
                        <Button 
                            variant="info" 
                            size="sm" 
                            onClick={() => { setDataEdit(selectedRow); setViewMode('edit'); }}
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-edit mr-1"></i> Sửa
                        </Button>
                        <Button 
                            variant="success" 
                            size="sm" 
                            onClick={() => { setDataEdit(selectedRow); setShowDieuKienModal(true); }}
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-clipboard-check mr-1"></i> Điều kiện quyết định
                        </Button>
                    </div>
                </Card.Footer>
            )}
        </Card>

        {showModal && (
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false} size="md">
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title>Cập nhật trạng thái</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Trạng thái <span className="text-danger">*</span></Form.Label>
                            <Form.Control as="select" value={trangThai} onChange={(e) => setTrangThai(e.target.value)}>
                                {objectTrangThaiKiemTraSoLieu.map((st) => (
                                    <option key={st.value} value={st.value}>{st.label}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Ghi chú {(trangThai === trangThaiKiemTraSoLieuValue.tuChoi || trangThai === trangThaiKiemTraSoLieuValue.boSung) && <span className="text-danger">*</span>}</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                placeholder="Nhập ghi chú (nếu có)..." 
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <DocumentInput
                                labelTitle="File tài liệu"
                                value={fileTaiLieu}
                                onChangeProp={(url) => setFileTaiLieu(url)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isSaving}>
                        Hủy
                    </Button>
                    <Button variant="primary" onClick={submitDuyet} disabled={isSaving || !trangThai || ((trangThai === trangThaiKiemTraSoLieuValue.tuChoi || trangThai === trangThaiKiemTraSoLieuValue.boSung) && !ghiChu.trim())}>
                        {isSaving ? 'Đang lưu...' : 'Lưu lại'}
                    </Button>
                </Modal.Footer>
            </Modal>
        )}
        
        {viewMode === 'edit' && dataEdit && (
            <KiemTraSoLieuEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} isView={false} />
        )}
        {viewMode === 'view' && dataEdit && (
            <KiemTraSoLieuEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} isView={true} />
        )}
        
        {showDieuKienModal && dataEdit && (
            <DieuKienQuyetDinhModalWrapper 
                dataEdit={dataEdit} 
                showDieuKienModal={showDieuKienModal} 
                setShowDieuKienModal={setShowDieuKienModal} 
                refetch={refetch} 
            />
        )}
        </>
    );
};

const DieuKienQuyetDinhModalWrapper = ({ dataEdit, showDieuKienModal, setShowDieuKienModal, refetch }) => {
    const [isEditMode, setIsEditMode] = useState(false);

    return (
        <Modal show={showDieuKienModal} onHide={() => setShowDieuKienModal(false)} backdrop="static" keyboard={false} size="xl">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{!isEditMode ? 'Kết quả điều kiện quyết định' : 'Điều kiện quyết định'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3 custom-modal-body" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', overflowX: 'hidden' }}>
                <DieuKienQuyetDinhForm 
                    kiemTraSoLieuId={dataEdit.id} 
                    kiemTraSoLieuData={dataEdit} 
                    readOnly={!isEditMode} 
                    isUserView={false} 
                    refetchParent={refetch} 
                    onDataLoaded={(hasData) => {
                        if (!hasData) {
                            setIsEditMode(true);
                        }
                    }}
                    onSaveSuccess={() => setIsEditMode(false)}
                />
            </Modal.Body>
            <Modal.Footer>
                {!isEditMode && (
                    <Button variant="warning" onClick={() => setIsEditMode(true)}>
                        <i className="fas fa-edit mr-1"></i> Cập nhật
                    </Button>
                )}
                <Button variant="secondary" onClick={() => setShowDieuKienModal(false)}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DuyetKiemTraSoLieu;
